import { SyntheticEvent, useEffect, useState } from 'react'
import { Position, Transform } from 'types'
import { Draggable } from 'ui'

type Props = {
    className?: string
    height: number
    defaultTransform: Transform
    persistFocus?: boolean
    width: number
    onContextMenu?: (e: SyntheticEvent<HTMLElement, MouseEvent>) => void
    onDoubleClick?: (e: SyntheticEvent<HTMLElement, MouseEvent>) => void
    onDrag: (position: Position) => void
    onDragEnd?: () => void
    onDragStart?: () => void
    onEllipsisMenu?: (e: SyntheticEvent<HTMLElement, MouseEvent>) => void
    onFocusChange?: (focused: boolean) => void
}

const ArtboardDraggableLayer = ({
    className,
    defaultTransform: t,
    height,
    persistFocus = false,
    width,
    onContextMenu,
    onDoubleClick,
    onDrag,
    onDragEnd: onDragEndProp,
    onDragStart: onDragStartProp,
    onEllipsisMenu,
    onFocusChange,
}: Props) => {
    const [defaultTransform, setDefaultTransform] = useState<Transform>(t)

    function scalePosition(transform: Transform) {
        const scaledHeight = Math.round(height * transform.scaleY)
        const scaledWidth = Math.round(width * transform.scaleX)

        onDrag({
            height: scaledHeight,
            rotation: Math.round(transform.rotation),
            width: scaledWidth,
            x: Math.round(transform.x - (scaledWidth - width) / 2),
            y: Math.round(transform.y - (scaledHeight - height) / 2),
        })
    }

    function onDragEnd(transform: Transform) {
        setDefaultTransform(transform)
        onDragEndProp?.()
    }

    function onDragMove(transform: Transform) {
        scalePosition(transform)
    }

    useEffect(() => {
        scalePosition(defaultTransform)
    }, [height, width])

    return (
        <Draggable
            className={className}
            defaultTransform={defaultTransform}
            height={height}
            persistFocus={persistFocus}
            rotateable
            scaleable
            style={{ position: 'absolute' }}
            width={width}
            onContextMenu={onContextMenu}
            onDoubleClick={onDoubleClick}
            onDragEnd={onDragEnd}
            onDragMove={onDragMove}
            onDragStart={() => onDragStartProp?.()}
            onEllipsisMenu={onEllipsisMenu}
            onFocusChange={onFocusChange}
        />
    )
}

export default ArtboardDraggableLayer
